<template>
  <div>
    <v-btn fab right x-small color="info" top @click="addListItem()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div ref="componentSection">
      <div class="mx-4" :id="'main-div'+index" v-if="content == ''">
        <v-alert
          contenteditable
          border="left"
          elevation="12"
          icon="mdi-school"
          class="text-center align-center teal darken-4 text--white"
        >
          <h1 style="color:white">Header Component</h1>
        </v-alert>
        <ol>
          <section
            :id="'ul'+index"
            contenteditable
            class="h2 text-center teal darken-4"
            style="outline: none;color:#3dc7be;border-radius:10%"
          ></section>
        </ol>
      </div>

      <div v-else v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "header", "del", "content"],

  mounted() {
    this.attachEventListeners();
  },
  updated() {
    this.attachEventListeners();
  },
  data() {
    return {
      listItems: [1]
    };
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    }
  },
  methods: {
    addListItem() {
      const ul = document.getElementById("ul" + this.index);
      const li = document.createElement("li");
      const br = document.createElement("br");
      li.innerHTML = "<v-icon left>mdi-school</v-icon> List Item";
      ul.append(li);
      li.append(br);
    },
    updateComponent() {
      const componentSection = this.$refs.componentSection;
      this.$store.commit("updateStoreComponent", {
        index: this.index,
        componentSection: componentSection.innerHTML
      });
    },

    attachEventListeners() {
      const mainDiv = document.getElementById("main-div" + this.index);
      mainDiv.addEventListener("focusout", () => {
        this.updateComponent();
      });
    }
  }
};
</script>

<style>
</style>